import React, { Component } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";

// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Badge,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButtonDropdown,
  ModalBody,DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown,
  Media,
  Modal,
  Table,
  UncontrolledPopover,
  PopoverBody,
  Popover
} from "reactstrap";
import { imageFileExtension, getImageFile, getRandomRolor,millisecondToHour, jobStatusAlert, addDisableScroll, removeDisableScroll } from "../../settings/shared/commonMethod"
import {
  Link
} from "react-router-dom";
import {
  RUN_PROGRESS_STATUS, INTERVALSEARCH
} from "settings/shared/constants";
import RunService from '../../services/api/Run';
import UserService from '../../services/api/User';
import ChatService from '../../services/api/Chat';
import { toast } from 'react-toastify';
// import { Modal } from "react-responsive-modal";
import Dialog from 'react-dialog'
import 'react-dialog/css/index.css'
import StorageService from '../../services/api/Storage';
import moment from 'moment'
import HashLoader from "react-spinners/HashLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { Scrollbars } from 'react-custom-scrollbars';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import profileIcon from '../../assets/img/proicon.png';
import ProjectService from '../../services/api/Project';
// import NotificationBadge from 'react-notification-badge';
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import TinyURL from "tinyurl";
import Linkify from 'react-linkify';
import Pagination from "../../assets/js/Pagination";
import Chip from '@material-ui/core/Chip';
import openpara from "assets/img/open.png";
// import ReactModal from 'react-modal-resizable-draggable';
import ChipInput from 'material-ui-chip-input'
import axios from 'axios'
import { uuidv4 } from '../../components/Notebook/operations/notebook'
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import Autosuggest from "react-autosuggest";
// import Compare from '../Analyze/Compare'
import Analyze from "../Analyze/Analyze";
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';
import Catalog from "views/Catalog/Catalog";

const styles = {
  chaticon: {
    cursor: 'pointer'
  },
  chatbutton: {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    boxShadow: 'transparent',
  },
  expandStyles: {
    backgroundColor: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1
  },
  expandStyles_Comman: {
    backgroundColor: "#000000",
    color: "#2dce89",
    fontSize: "0.2rem",
    letterSpacing: 1,
    width: 550,
    height: 'auto',
    marginTop: 5,
    marginLeft: 30,
    marginBottom: 2
  },
  expandStyles_param: {
    fontSize: "0.8rem",
    letterSpacing: 1,
    width: 550,
    marginTop: 5,
    marginLeft: 30
  },
  logbtn: {
    backgroundColor: "#5e72e4",
    color: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1,
    borderRadius: 8,
    height: 30,
    width: 50,
    padding: 0,
    marginLeft: 10
  },
  removedialog: {
    top: '50%',
    width: '250px'
  },

  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    // padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
}
const colours = ['red', 'orange', 'yellow', 'blue', 'green', 'indigo', 'violet'];


function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  return (
    <span>{suggestion.name}</span>
  );
}

class Runs extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.searchTimeOut = 0;
    this.onPageChange = this.onPageChange.bind(this);
    this.state = {
      input: "",
      messages: [],
      input_user: [],
      input_userEmail: [],
      open: false,
      products: [],
      columns: [],
      chatMsg: [],
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      logState: false,
      expanded: {},
      runname: "",
      filter: false,
      count: 0,
      logDetails: [],
      parasetm: [],
      UserList: [],
      filtered: [],
      updatePageNumber: 0,
      totalPages: 0,
      showuserListFlag: false,
      countitem: 0,
      rundatalength: '',
      runprojectname: '',
      copied: false,
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      isRunActionOpen: false,
      modalParameter: false,
      chatrundata: [],
      tags: [],
      randomcolor: '',
      DownloadUrl: '',
      myContent: '',
      fileType: '',
      parametersTablesdata: [],
      paraset: [],
      parasetTblState: [],
      parasetvalue: '',
      parameterSet: [],
      dropdownOpen: false,
      filterBy: "Runs",
      suggestions: [],
      value: "",
      tabId:"Runs",
      checked: [],
      selected:[],
      selectedRows:[],
      compareRow:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight
     };
        this.toggleRow = this.toggleRow.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentDidMount() {
    window.removeEventListener("ws-message-run", this.eventListerForRun);
    this.GetChatUnreadCount();
    this.GetRunsData();
    localStorage.removeItem("sharefilelink")
    localStorage.removeItem("filePathStorage")
    localStorage.removeItem("Pagehistory");
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("ws-message-run", this.eventListerForRun);
    addDisableScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("ws-message-run", this.eventListerForRun);
    removeDisableScroll();
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }


  eventListerForRun = (event) => {
    if (event !== undefined) {
      let noteData = event.detail.data;
      if (this.state.products.length > 0 && noteData !== undefined) {
        var productFilter = this.state.products.filter(item => item.Id === parseInt(noteData.runId))
        if (productFilter.length !== 0 || noteData.runStatus === RUN_PROGRESS_STATUS ) {
          jobStatusAlert(noteData.runId, noteData.runStatus, noteData.createdBy);
            this.setState({
              socketLoadFlag: true,
            }, () => {
              this.GetRunsData();
            })
        } else {
          jobStatusAlert(noteData.runId, noteData.runStatus, noteData.createdBy)
        }
      }
    }
  }

  handleCallback = (childData) =>{
    this.setState({ram: childData})
    this.state.ram =childData
    let parseGetData= JSON.parse(this.state.ram);
    let analyseData = {}
    parseGetData.map((item,index) => {
      analyseData[item.jobId] = true
  })
this.state.selected = analyseData
this.state.compareRow =parseGetData
}
  callRow = (event,rowInfo,nval) =>{
    event.preventDefault()
    let checkedrow =[]
    let remcheckId=rowInfo.Id;
  if (this.state.compareRow.some(item=>item.checkId===remcheckId) === false) {  // if id is not present ADD it
    checkedrow = {
      label:rowInfo.Name.key + " _ " + rowInfo.Id,
      jobId:rowInfo.Id,
      id:rowInfo.DbId,
      value:rowInfo.DbId,
      runDbId:rowInfo.DbId,
      checkval:nval,
      checkId:rowInfo.Id,
      checkName:rowInfo.Name.key,  
      modalcode: rowInfo.modelOutputCodeFiles ,
      output:rowInfo.OutputFile,
      parameter:rowInfo.parameterSet,
      runBy:rowInfo.createdBy,
      masterJobId:rowInfo.masterJobId,
      hideCodeCells:rowInfo.hideCodeCells
      }
      this.state.compareRow = [...this.state.compareRow, checkedrow];
      let analyseData = {}
      this.state.compareRow.map((item,index) => {
        analyseData[item.jobId] = true
    })
    this.setState({
      selected: analyseData,
    });
  }
  else{
    this.setState(({compareRow}) => ({compareRow: compareRow.filter(item => item.checkId !== remcheckId)}));
    this.state.compareRow =this.state.compareRow.filter(item => item.checkId !== remcheckId)
    // console.log('PRESENT',this.state.compareRow)
    let analyseData = {}
    this.state.compareRow.map((item,index) => {
      analyseData[item.jobId] = true
  })
  this.setState({
    selected: analyseData,
  });
  }
  }
  toggleRow(Id) {
    // const newSelected = Object.assign({}, this.state.selected);
    // newSelected[Id] = !this.state.selected[Id];
		// this.setState({
    //   selected: newSelected,
    // });
    // console.log('checkedCopy',this.state.selected)
  }
  handleCheckChange = () => {
    var selectAll = !this.state.selectAll;
    this.setState({ selectAll: selectAll });
    var checkedCopy = [];
    this.state.products.forEach(function(e, index) {
      checkedCopy.push(selectAll);
    });
    this.setState({
      checked: checkedCopy
    });
  };
  handleSingleCheckboxChange = (index) => {
    var checkedCopy = this.state.checked;
    checkedCopy[index] = !this.state.checked[index];
    if (checkedCopy[index] === false) {
      this.setState({ selectAll: false });
    }
    this.setState({
      checked: checkedCopy
    });
  };


  FilterData = () => {
    this.setState({ count: this.state.count + 1 });
    if (this.state.count % 2 === 0) {
      this.setState({ filter: true, filtered: [] });
    }
    else {
      this.setState({ filter: false }, () => { this.GetRunsData() });
    }
  }

  onDismiss = () => { };
  toggleModalParameter = (parasettbl, parasetvalue) => {
    this.setState({
      modalParameter: !this.state.modalParameter,
      parasetTblState: parasettbl,
      parasetvalue: parasetvalue
    },()=>{
      this.ConstructParameterTable(this.state.parasetTblState)
    });
  };
  // convert default view(table) to detailed view(string)
  ConstructParameterTable = (detailedView) => {
    let appendParamTable = "";
    for (var i = 0; i < detailedView.length; i++) {
      if (detailedView[i].key === null && detailedView[i].row === false) {
        appendParamTable = appendParamTable + detailedView[i].value + "\n";
      }
      else {
      if(detailedView[i].key === "" && detailedView[i].value === ""){
        appendParamTable = appendParamTable + detailedView[i].value + "\n";
      } 
      else{
        appendParamTable = appendParamTable + detailedView[i].key + "=" + detailedView[i].value + "\n";
      }      
      }
    }
    this.setState({
      parasetvalue: appendParamTable
    })
  }
  //Get Run table data
  GetRunsData = () => {
    if (!this.state.socketLoadFlag) {
      this.setState({ loading: true });
    }
    let postData = {
      projectId: null
    }
    let size = 15;
    RunService.getRunbySize(postData, this.state.updatePageNumber, size)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let runSDTO = response.runDetails.content;
          //  console.log('runSDTO', response)
          this.renderData(runSDTO);
          this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array

          // RunService.GetChats(runId)
          // .then((response) => {
          //   this.state.countitem = response.length;
          //   // console.log(response)
          //   this.setState({
          //     chatMsg: response
          //   })
          //   let uId = localStorage.getItem("Uid");
          //   this.GetAllUsers(uId);
          // })


        } else {
          this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array    
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      })
    // if (this.state.chatDbId != null) {
    //   this.LoadChats(this.state.chatDbId);
    // }
  }


  addChip = (id, value, tags) => {
    var i = Math.floor(Math.random() * colours.length);
    var getData = this.state.products.filter(item => item.DbId === id);
    var index = this.state.products.findIndex(function (item, i) {
      return item.DbId === id
    });
    getData[0].Tags.push(value)
    this.state.products[index] = getData[0];
    this.setState({
      products: this.state.products,
      randomcolor: colours[i]
    })
    this.CreateTags(id, tags);
  };
  getColor = () => {
    let colorCode = getRandomRolor();
    return colorCode;
  }

  removeChip = (id, index) => {
    var getData = this.state.products.filter(item => item.DbId === id);
    var productIndex = this.state.products.findIndex(function (item, i) {
      return item.DbId === id
    });
    getData[0].Tags.splice(index, 1)
    this.state.products[productIndex] = getData[0];
    this.setState({ products: this.state.products })
    this.CreateTags(id, getData[0].Tags);
  };


  CreateTags = (id, tags) => {
    RunService.createTags(id, tags)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          // toast.success("Tags Updated Successfully!");
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      });
  }

  CallJobRun = (jobrunid, masterId, chatMasterIdentifier, name) => {
    let reg = "/runs";
    localStorage.setItem("Pagehistory", "Run");
    this.props.history.push("/job/" + chatMasterIdentifier + "?__o=" + reg)
  }

  displayUnreadCount(chatmasterId) {
    let chatCount = 0;
    if (chatmasterId === null || chatmasterId === undefined) {
      chatCount = 0;
    } else {
      var filterData = this.state.chatrundata.filter(f => f.chatMasterId === chatmasterId);
      chatCount = filterData[0] !== undefined ? filterData[0].totalUnreadMessages : 0;
    }
    return <span>{chatCount !== 0 && <sup><span className="badge badge-success">{chatCount}</span></sup>}</span>
  }


  showLogPopup = (jobId) => {
    document.getElementById("runStatus").click();
    this.HideandShowLog(this.state.logState, jobId, null)
  }

  GetChatUnreadCount = () => {
    ChatService.GetChatRunIds(this.state.updatePageNumber, 10).then((response) => {
      if (response !== "") {  // if chat response is 204 execure this condtion
        this.setState({ chatrundata: response.chatItems });
      }
    });
  }

  closeErrorDialog = () => {
    document.getElementById("closeDialog").click();
  }

  //Display Run table
  renderData(runData) {
    let datas = [];
    this.setState({
      rundatalength : runData.length,
      runprojectname : "Demo Project",
      products : []
    })
    // console.log('runData', runData)
    runData.forEach((item, index) => {
      let parametersTables_array = []
      let parametersTables_files = item.parametersTables
      if (parametersTables_files !== null) {
        for (let index = 0; index < parametersTables_files.length; index++) {
          parametersTables_array.push(parametersTables_files[index])
        }
        this.setState({
          parametersTablesdata: parametersTables_array,
          parameterSet: item.parameterSet === null ? "":item.parameterSet
        });
      }
      else {
        this.setState({
          parametersTablesdata: []
        });
      }
      if (item.runStatus === "Cancelled") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Completed") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Failed") {
        this.setState({ disabled: 'disabled' });
      } else {
        this.setState({ disabled: 'false' });
      }
      this.state.runname = item.name;
      let PrefixCodeFiles = [];
      if (item.codeFilesPrefix === null) {
        PrefixCodeFiles = item.modelCodeFiles
      } else if (item.codeFilesPrefix.length > 0) {
        var pre = item.codeFilesPrefix;
        var arr = item.modelCodeFiles
        var newArr = (pre + arr.join(';' + pre)).split(';');
        PrefixCodeFiles = newArr;
      } else {
        PrefixCodeFiles = item.modelCodeFiles
      }

      if(item.hideCodeCells === true ){
        this.setState({hideCodeCells:"true"})
        }
       else{
        this.setState({hideCodeCells:"false"})
      }



      // RunService.GetMessages(item.jobId)
      //     .then((response) => {
      //       console.log('GetMessages',response[0].chatDOS.length)
      //       this.state.countitem = response[0].chatDOS.length;
      //       item.totalMessages =  response[0].chatDOS.length;
      //     })
      datas.push({
        Name:
          // <span title={item.name} className="overflowStyle overflowStyleWithIcon" key={item.name}>{item.name}</span>,
          <span title={item.name} className="overflowStyle" key={item.name}>{item.name}</span>,
          fullName:item.name,
        Id: item.jobId, Description: item.description,
        RunTime: <span className="overflowStyle">{millisecondToHour(item.runTimeInMilliseconds,item.runStatus)}</span>,
        Cluster: <span title={item.clusterName} className="overflowStyle">{item.clusterName}</span>,
        hideCodeCells: this.state.hideCodeCells,

        //  Input:<div> <a href="#"><u> {item.modelInputFiles.length==0?"":"Input"}</u></a> </div>,
        //  Output:<div> <a href="#"><u>{item.outputFiles.length==0?"":"Output"}</u></a> {item.outputFiles.length==0?"":<span id="Download"><i className="fas fa-cloud-download-alt"></i></span>} </div>,
        Status:
          <div key={item.runStatus}>
            {(item.runStatus === "Starting" || item.runStatus === "Progress") &&
              <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.runStatus}</Badge>
            }
            {item.runStatus === "Executing" &&
              <Badge color="" className="badge-dot"><i className="bg-success blink" />{item.runStatus}</Badge>
            }
            {item.runStatus === "Cancelled" &&
              <Badge color="" className="badge-dot"><i className="bg-darkgray" />{item.runStatus}</Badge>
            }
            {item.runStatus === "Completed" &&
              <Badge color="" className="badge-dot"><i className="bg-blue" />{item.runStatus}</Badge>
            }
            {item.runStatus === "Failed" && 
                  <UncontrolledDropdown size="sm" className="float-right mt-2 statusmsg" id="runStatus" direction={(index > 6 ? "up" : "down")}>
                    <DropdownToggle
                    nav
                    tag="span"
                  >
                    <span className="websocketfontStyle"><Badge color="" className="badge-dot"><i className="bg-red" />{item.runStatus}</Badge>
                      &nbsp; &nbsp;<i className="fas fa-info-circle"></i></span>

                  </DropdownToggle>
                  {item.runFailedMsg !== null && item.errorName !== null && item.errorValue !== null ? <DropdownMenu
                    className="dropdown-menu-arrow popoverCard  p-3 rounded-lg h-auto df-run-failed"
                    top
                  >
                    { item.runFailedMsg === "Failed" && <>
                      <div className="err-title">
                        <p><span className="error-popup"><i className="fas fa-times df-text-white"></i></span>
                        <span className="text-capitalize p-1 error-icon">{item.errorName}</span></p>
                        <span onClick={e => this.closeErrorDialog()} className="actionicon"><i className="fas fa-times df-text-dark"></i></span>
                      </div>
                      <div className="err-content">
                          <span className="text-muted p-1 w-100 failedmsg text-left d-block">{item.errorValue}</span>
                          <div className="d-flex justify-content-center">
                                <Button className="err-button float-left"
                                onClick={e => {
                                  e.preventDefault();
                                  this.showLogPopup(item.jobId);
                                }}>Log</Button>

                              <Button className="err-button float-right"
                              onClick={e => 
                                item.modelOutputCodeFiles !== null && item.modelOutputCodeFiles !== undefined
                                && item.modelOutputCodeFiles.length > 0 ? this.OpenStorageView(item.modelOutputCodeFiles[0], e, item.hideCodeCells) : "" }
                            ><i className="fas fa-share-square"></i> Details</Button>
                          </div>
                      </div>
                      </>}
                      { item.runFailedMsg !== "Failed" && <>
                    <span className="text-capitalize p-2">No error message found</span>
                      </>}
                  </DropdownMenu> : <DropdownMenu
                    className="dropdown-menu-arrow popoverCard  p-3 rounded-lg h-auto df-run-failed noerror-message"
                    top
                  >
                    <span className="text-capitalize p-2">No error message found</span>
                  </DropdownMenu>}
                  </UncontrolledDropdown>
            }
          </div>,
        Cost: item.cost,
        DbId: item.id,
        scheduleId:item.scheduleId,
        createdBy: <span title={item.createdBy} className="overflowStyle">{item.createdBy}</span>,
        InputFile: item.modelInputFiles || [],
        InputFolders: item.modelInputFolders || [],
        CodeFile: PrefixCodeFiles || [],
        CodeFolders: item.modelCodeFolders || [],
        modelOutputCodeFiles: item.modelOutputCodeFiles !== null ? item.modelOutputCodeFiles : [],
        modelOutputCodeFolders: item.modelOutputCodeFolders !== null ? item.modelOutputCodeFolders : [],  //new
        OutputFile: item.modelOutputFiles !== null ? item.modelOutputFiles : [],
        modelOutputFolders: item.modelOutputFolders !== null ? item.modelOutputFolders : [],   //new
        Tags: item.tags || [],
        LogFiles: item.logEntries,
        Parameter: this.state.parametersTablesdata,
        // Parameter:item.parametersTables.length > 0 ? parametersTables_array : [],
        // parameterSet:item.parameterSet,
        parameterSet: this.state.parameterSet,
        StartTime:  <div key={item.startTime}>{item.startTime !== null ? moment.utc(item.startTime).local().format('MMM DD, YYYY') : ""} <br></br>{item.startTime !== null ? moment.utc(item.startTime).local().format('hh:mm A') : ""}<br /></div>,
        EndTime: <div key={item.endTime}>{item.endTime !== null ? moment.utc(item.endTime).local().format('MMM DD, YYYY') : ""}<br></br> {item.endTime !== null ? moment.utc(item.endTime).local().format('hh:mm A') : ""}</div>,
        Comments: <div className="">  <button className="btn-icon-only text-blue" size="sm" role="button"
          color="" style={styles.chatbutton}
          // onClick={e => this.CallJobRun(item.jobId,item.totalUnreadMessages,item.masterJobId,item.chatMasterId,item.name)}
          onClick={e => this.CallJobRun(item.jobId, item.chatMasterId, item.chatMasterIdentifier, item.name)}

        >
          <i className="far fa-comments text-blue" />
          {this.displayUnreadCount(item.chatMasterId)}
        </button> </div>,
        Action:
          <div className="">
            <div className="row">
            <span className="actionicon" onClick={e => {
                  e.preventDefault()
                  this.updateRerun(item.id, item.masterJobId)
                  }}>Rerun | &nbsp;
            </span>
              <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
                <DropdownToggle
                  tag="span"
                  onClick={e => e.preventDefault()}
                  style={{ color: '#007bff', cursor: 'pointer' }}
                >
                  <i className="fas fa-ellipsis-v" />
                </DropdownToggle>
                <DropdownMenu
                  persist right
                  className="dropdown-menu-arrow"
                >
                
                  <DropdownItem
                    href=""
                    className={this.state.disabledclone}
                    onClick={e => {
                      e.preventDefault() 
                      this.cloneProject(item.id, item.masterJobId, item.name)
                      // this.cloneProject(item.masterJobId, item.name)
                    }} >
                    <span>
                      <i className="far fa-clone text-red mr-3" /> Clone as Project
                    </span>
                  </DropdownItem>
                   
                  <DropdownItem
                    onClick={e => this.cancelJobConfirmation(item.jobId, item.id)}
                    className={item.startTime !== null ? this.state.disabled : ""}
                  >
                    {/*<input type="hidden" value={item.id} id="itemid" ></input>*/}
                    <span>
                      <i className="fas fa-times text-red mr-3" /> Cancel Job
                                </span>
                  </DropdownItem>
                  {/* <DropdownItem
                    // onClick={e => this.submitcancel(item.jobId)}
                    className={this.state.disabled}
                  >
                    <span>
                      <i className="fas fa-calendar-times mr-3"></i> Cancel Schedule
                    </span>
                  </DropdownItem> */}
                  <DropdownItem
                    onClick={e => this.jobRemoveConfirmation(item.jobId, item.id)}
                  >
                    {/*<input type="hidden" value={item.id} id="removeid" ></input>*/}
                    <span> <i className="fas fa-archive text-red mr-3"></i>
                                 Remove Job
                                </span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

            </div>
          </div>
      })
    });
    var checkedCopy = [];
    var selectAll = this.state.selectAll;
    datas.forEach(function(e, index) {
      checkedCopy.push(selectAll);
    });

    this.setState({
      products: datas,
      checked: checkedCopy,
      selectAll: selectAll
    });

  }

  clickOnAction = (event) => {
    event.preventDefault()
  }

  jobRemoveConfirmation = (jobId, removeId) => {
    // this.state.jobId = jobId;
    confirmAlert({
      title: 'Remove Job',
      message: 'Are you sure to remove this job -' + jobId + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.RemoveAction(removeId)
        },
        {
          label: 'No',
          onClick: () => {
            // console.log('no')
          }
        }
      ]
    });
  }

  updateRerun = (id, masterJobId) => {
    let reg = "/runs";
    localStorage.setItem("Pagehistory", "runs");
    this.props.history.push({
      pathname: '/newProject/' + "?__o=" + reg,
      state: { mode: "reRun", rerunId: id, projectId: masterJobId }
    })
  }


  cloneProject = (id, masterJobId, name) => {
    let reg = "/runs";
    localStorage.setItem("Pagehistory", "runs");
    this.props.history.push({
      pathname: '/newProject/' + "?__o=" + reg,
      state: { mode: "cloneProject", cloneId: id, editId: masterJobId, editProject: name , from:'runs'}
    })
  }

  openDialog = (itemid) => {
    this.setState({ isDialogOpen: true, dialogid: itemid})
  }

  // Handling remove job actions
  RemoveAction = (rid) => {
    if (rid !== undefined && rid !== null) {
      let RemoveJobdto = {
        id: rid
      }
      RunService.removeJob(RemoveJobdto)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetRunsData(); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);           }
        });
    }
  }

  handleChange = (event) => {
    this.setState({ input: event.target.value });
  }

  onPageChange(pageIndex) {
    this.setState({
      updatePageNumber: pageIndex,
    }, () => {
      this.GetChatUnreadCount(); // Load chat run data
      if (this.state.filtered.length !== 0) {
        this.filterMethod(this.state.filtered)
      } else {
        this.GetRunsData()
      }
    });
  }

  handleDelete = (item) => {
    var index_user = this.state.input_user.indexOf(item);
    var index_email = this.state.input_userEmail.findIndex(obj => obj['user'] === item);
    this.state.input_user.splice(index_user, 1);
    this.state.input_userEmail.splice(index_email, 1);
    this.setState({
      input_user: this.state.input_user,
      input_userEmail: this.state.input_userEmail
    })
    if (this.state.input_user.length === 0) {
      let uId = localStorage.getItem("Uid");
      this.GetAllUsers(uId);
    }
  };

  userselectedValue = (firstName, lastName, email) => {
    let myappendUser = "@" + firstName + " " + lastName
    let selectedEmail = { user: myappendUser, email: email };
    const filteredArray = this.state.UserList.filter((res) => res.firstName !== firstName);
    this.setState({
      input: "",
      input_userEmail: [...this.state.input_userEmail, selectedEmail],
      input_user: [...this.state.input_user, myappendUser],
      UserList: filteredArray
    })
  }

  keyPressed = (event) => {
    if (event.keyCode === 13) {
      this.submitMessage()
    } else if (event.keyCode === 50) {
      this.setState({ showuserListFlag: true });
    } else {
      this.setState({ showuserListFlag: false });
    }
  }

  submitMessage = () => {
    let emailList = [];
    for (let i = 0; i < this.state.input_userEmail.length; i++) {
      emailList.push(this.state.input_userEmail[i].email);
    }
    let chatPaylad = {
      "runDBId": this.state.chatDbId,
      "message": this.state.input_user + " " + this.state.input,
      "mentionedUsers": emailList
    }
    RunService.Postchat(chatPaylad)
      .then((response) => {
        this.setState(
          {
            messages: [...this.state.messages, this.state.input_user + " " + this.state.input],
            input: "",
            input_user: [],
            input_userEmail: []
          }
        );
      })
    let uId = localStorage.getItem("Uid");
    this.GetAllUsers(uId);
  }

  clearMessages = () => {
    this.setState({ messages: [] });
  }

  handleClose = () => {
    this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false, modalParameter: false })
  }

  // cancel job
  cancelJobConfirmation = (jobId, cancelId) => {
    // this.state.cancelId = cancelId;
    confirmAlert({
      title: 'Cancel Job',
      message: 'Are you sure to cancel this job -' + jobId + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.HandlingAction(cancelId)
        },
        {
          label: 'No',
          onClick: () => {
            // console.log('no')
          }
        }
      ]
    });
  }

  // Handling cancel job actions
  HandlingAction = (uid) => {
    if (uid !== undefined && uid !== null) {
      let JobPayload = {
        id: uid
      }
      RunService.cancelJob(JobPayload)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            this.GetRunsData(); // Reload runs data
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);           }
        });
    }
  }

  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }


  // Hide and Show Log for each run
  HideandShowLog(flag, fileName, log) {
    this.setState({ modalloading: true, myContent: '' });
    let filepath = "jobs/" + fileName + "/logs/console.log"
    StorageService.downloadObjectUrl(filepath)
      .then((response) => {
        this.renderText(response.download_url);
        this.setState({ modalloading: false, DownloadUrl: response.download_url });
      }).catch((error) => {
        this.setState({ modalloading: false });
      });;
    this.setState({
      logState: !flag,
      isDialogOpen: true,
      logDetails: log
    })
  }
  renderText = (url) => {
    axios.get(url)
      .then(response => {
        this.setState({
          fileType: "others",
          myContent: response.data.toString()
        })
      })
      .catch(error => {
        // console.log(error);
        return error;
      });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false, modalParameter: false });
  }
  onOpenModal = (runId, commentid) => {
    this.setState({
      open: true,
      chatDbId: runId,
      commentid : commentid
    },()=>{
      this.LoadChats(runId);
    });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  // Load all chats for particular run id
  LoadChats = (runId) => {
    let profile = JSON.parse(localStorage.getItem("UserProfile"));
    this.setState({
      localName: profile.firstName + " " + profile.lastName,
      localPhoto: profile.photoURL,
      input: '',
      messages: []
    });
    RunService.GetChats(runId)
      .then((response) => {
        this.setState({
          countitem : response.length,
          chatMsg: response
        },()=>{
          let uId = localStorage.getItem("Uid");
          this.GetAllUsers(uId);        
        })
      })
  }

  GetAllUsers = (allid) => {
    UserService.getAllUsers(this.state.usersid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
          let users = []
          let i;
          for (i = 0; i < response.userDTOS.length; i++) {
            if (loggedInUser.email !== response.userDTOS[i].email) {
              users.push(response.userDTOS[i])
            }
          }
          this.setState({
            UserList: users
          });

        } else {
          // console.log(response.errorMessage);
        }
      })
  }
  OpenStorageView = (name, event, hidevalue) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/runs";
    let path = name.slice(-1) === "/" ? "/storage?path=" + name : "/storageView?file=" + name + "&hideCodeCells=" + hidevalue; // check folder or file
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }

  copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 
  }

  GetLink = (name, event, from) => {
    this.setState({ loading: true })
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/runs";
    let redirectUrl = currentUrl.replace(reg, "/storageView?file=" + name);
    TinyURL.shorten(redirectUrl).then((res) => {
      this.setState({ copiedtxt: res })
      var tempInput = document.createElement("input");
      tempInput.value = this.state.copiedtxt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      if (from === "modelinput") {
        this.setState({ copiedmodelinput: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modelcode") {
        this.setState({ copiedmodelcode: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modeloutputfile") {
        this.setState({ copiedmodeloutputfile: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modeloutputcodefile") {
        this.setState({ copiedmodeloutputcodefile: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      }
    })
  }

  closeerror = () => {
    this.setState({ loading: false, copiedmodelinput: "", copiedmodelcode: "", copiedmodeloutputfile: "", copiedmodeloutputcodefile: "" })
  }

  changeColumnName = (column) => {
    let ColumnName = ""
    if (column === "Name") { ColumnName = "name" }
    if (column === "RunTime") { ColumnName = "runTime" }
    if (column === "Cluster") { ColumnName = "clusterName" }
    if (column === "Id") { ColumnName = "jobId" }
    if (column === "Status") { ColumnName = "runStatus" }
    if (column === "StartTime") { ColumnName = "startTime" }
    if (column === "EndTime") { ColumnName = "endTime" }
    if (column === "createdBy") { ColumnName = "createdBy" }
    return ColumnName;
  }

  filterMethod = (filter) => {
    this.setState({ filtered: filter }, () => {
      if (this.state.filtered.length === 2) {
        this.state.filtered.splice(0, 1);
      }
    })
    if (filter.length !== 0) {
      if (filter[filter.length - 1].id === "Id" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].id === "RunTime" && filter[filter.length - 1].value.length > 1) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      } else if (filter[filter.length - 1].value.length > 2) {
        this.filterDataLoadDelay(filter, this.state.updatePageNumber)
      }
    } else {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.GetRunsData();
      }, 1500);
    }
  }

  filterDataLoadDelay = (filter, pageNumber) => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.filterDataLoad(filter, pageNumber)

    }, 300);
  }

  async filterDataLoad(filter, pageNumber) {
    let size = 15;
    var runData = {};
    if(this.changeColumnName(filter[filter.length - 1].id) === "name" || this.changeColumnName(filter[filter.length - 1].id) === "jobId"){
      runData["jobIdOrNameStartsWith"] = filter[filter.length - 1].value
    }else{
      runData[this.changeColumnName(filter[filter.length - 1].id)] = filter[filter.length - 1].value
    }
    runData["projectIds"] = []
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = await new Promise(resolve => setTimeout(resolve, INTERVALSEARCH));
      const response = await RunService.getRunSearch(runData, pageNumber, size);
      if (response.status === 'SUCCESS') {
        let runSDTO = response.runDetails.content;
        this.renderData(runSDTO);
        this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
      } else {
        this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
  };

  handleAddRow = () => {
    const item = {
      key: "",
      value: ""
    };
    this.setState({
      parametersTablesdata: [...this.state.parametersTablesdata, item]
    });
  };


  searchBy = (value) => {
    this.setState({
      filterBy: value,
      value: "",
    })
    this.GetRunsData();
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.GetRunsData();
    }
  };
  onChangeTags = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.GetRunsData();
    }
  };


  onClickSchedulerId = (id) => {
    this.props.history.push("/schedule?id="+id+"&scheduleFor=runs")
  }


  onSuggestionsRunsFetchRequested = ({ value }) => {
    let page = 0;
    let limit = 20;
    let tagOption = [];
    if (value === "") {
      this.GetRunsData();
    }
    var runData = {};
    runData["jobIdOrNameStartsWith"] = value
    runData["projectIds"] = []
    RunService.getRunSearch(runData, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.runDetails.content;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i].name + " _ " + myTags[i].jobId,
              value: myTags[i].jobId,
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      });
  }
  onSuggestionRunsSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    let page = 0;
    let limit = 20;
    var runData = {};
    runData["jobIdOrNameStartsWith"] = suggestion.value
    runData["projectIds"] = []
    RunService.getRunSearch(runData, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myProject = response.runDetails.content;
          this.renderData(myProject);

        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      });
  }
  onSuggestionsTagFetchRequested = ({ value }) => {
    let page = 0;
    let limit = 50;
    let tagOption = [];
    if (value === "") {
      this.GetRunsData();
    }
    RunService.GetRunTags(value, page, limit)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.tagListAutoComplete;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i],
              value: myTags[i],
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      });
  }
  onSuggestionTagSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    RunService.GetRunTagsValue(suggestion.name)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myProject = response.runDTOS;
          // console.log('myProject', response)

          this.renderData(myProject);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);         }
      });
  }
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  handleClick = (e) => {
    e.preventDefault();
      if(e.type === "contextmenu") {
        var arrt = e.currentTarget.getAttribute("data_attr_id");
        document.getElementById(arrt).click();
    }  
  }

  render() {
    const { open, value, suggestions } = this.state;
    // const uid = this.state.dialogid;
    // const rid = this.state.removedialogid;
    const inputPropsruns = {
      placeholder: "Search By Runs",
      value,
      onChange: this.onChange,
      id: "SRuns",
    };
    const inputPropstags = {
      placeholder: "Search By Tags",
      value,
      onChange: this.onChangeTags,
      id: "STag",
    };
    return (
    
        <>
          <PanelHeader
            content={
              <div className="header text-center">

              </div>
            }
          />
          <div className="content" id="closeDialog">
          <LoadingOverlay
          active={this.state.loading}
          spinner={<ScaleLoader
          height={35}
          width={5}
          radius={2}
          margin={2}
          color={"#123abc"}
          loading={this.state.loading}
        />}
      >
            <Card>
              <CardBody>
              <div className="carcontent">
              <Scrollbars autoHeight autoHeightMin={this.state.sheight-100}>
                <Tabs defaultTab="Runs" 
               onChange={(tabId) => { this.setState({tabId:tabId});
              }}> 
                  <TabList>
                    <Row>
                      <div className="col-4">
                        <Tab tabFor="Runs" className="add-data-tab"> Runs </Tab>
                        <Tab tabFor="Compare" className="add-data-tab"> Compare</Tab>
                        <Tab tabFor="Catalog" className="add-data-tab"> Catalog</Tab>
                      </div>
                      <div className="col-6">
                      {this.state.tabId === "Runs" && <div>
                        <InputGroup className="prosrch">
                          <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                            <DropdownToggle caret>
                              {this.state.filterBy}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={e => this.searchBy('Runs')}>Runs &nbsp;</DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem onClick={e => this.searchBy('Tags')}>Tags &nbsp;</DropdownItem>
                            </DropdownMenu>
                          </InputGroupButtonDropdown>
                          {this.state.filterBy === "Runs" &&
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsRunsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              onSuggestionSelected={this.onSuggestionRunsSelected}
                              inputProps={inputPropsruns} />
                          }
                          {this.state.filterBy === "Tags" &&
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsTagFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              onSuggestionSelected={this.onSuggestionTagSelected}
                              inputProps={inputPropstags} />

                          }
                        </InputGroup>
                        </div>
                        }
                      </div>
                      <div className="col-2 text-right">
                        <Link to="runs" >
                          <span> <i className="fas fa-sync-alt mr-3" onClick={e => this.GetRunsData()} /></span>
                        </Link>
                      </div>
                    </Row>
                  </TabList>
                  <TabPanel tabId="Runs">

                    <ReactTable
                      PaginationComponent={Pagination}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: e => {
                              // {this.state.selected[rowInfo.row.Id] === true ? this.callRow(rowInfo,'false') : this.callRow(rowInfo,'true')}
                          },
                            style: {
                              background: this.state.selected[rowInfo.row.Id] === true ? 'rgb(223 227 233)' : 'white',
                              color:this.state.selected[rowInfo.row.Id] === true ? 'black' : 'black'
                            }
                          }
                        }else{
                          return {
                        
                          }
                        }
                      }}
                      onFilteredChange={filtered => this.filterMethod(filtered)}
                      filtered={this.state.filtered}
                      data={this.state.products}
                      manual
                      expanded={this.state.expanded}
                      onExpandedChange={(expanded, index, event) => {
                        this.setState({ expanded });
                      }}
                      columns={
                        [
                          {
                            Header: "",
                            columns: [
                              {
                                expander: true,
                                Header: () => <strong className="filterdata" onClick={e => this.FilterData()}>&nbsp; &nbsp; &nbsp;<i className="fas fa-filter"></i> </strong>,
                                width: 60,
                                Expander: ({ isExpanded, ...rest }) =>
                                  <div>

                                    {isExpanded
                                      ? <span style={{verticalAlign:"text-bottom"}}>-</span>
                                      : <span style={{verticalAlign:"text-bottom"}}>+</span>}
                                  </div>,
                                style: {
                                  cursor: "pointer",
                                  fontSize: 20,
                                  padding: "0",
                                  textAlign: "center",
                                  userSelect: "none"
                                },
                              }
                            ]
                          },
                          {
                            id: "checkbox",
                            accessor: "",
                            Cell: ({ original}) => {
                              return (   
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  disabled={original.Status.key === "Completed" ? false : true}
                                  title="Select to Compare"
                                  checked={this.state.selected[original.Id] === true}
                                  onChange={() => this.toggleRow(original.Id)}
                                  onClick = { (e) => {this.state.selected[original.Id] === true ? this.callRow(e,original,'false') : this.callRow(e,original,'true')}}

                                />
                            
                              );
                            },
                            sortable: false,
                            width: 45,
                          
                          },
                          {
                            id: "scheduler",
                            accessor: "",
                            Cell: ({ original}) => {
                              return (   
                              original.scheduleId !== null && <i className="far fa-clock" title="Scheduled Run" style={{verticalAlign:"baseline",color:"#4776d9"}}/>
                              );
                            },
                            sortable: false,
                            width: 20,
                          
                          },
                          {
                            Header: 'Name',
                            accessor: 'Name',
                            maxWidth: 400,
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'fullName',
                            accessor: 'fullName',
                            show: false
                        
                          },
                          {
                            Header: 'Tags',
                            accessor: 'Tags',
                            show: false
                          },
                          {
                            Header: 'scheduleId',
                            accessor: 'scheduleId',
                            show: false
                          },
                          {
                            Header: 'DbId',
                            accessor: 'DbId',
                            show: false
                          },
                          {
                            Header: 'Id',
                            accessor: 'Id',
                            maxWidth: 70,
                            filterable: this.state.filter,
                            // sortable: true,
                            // filterable: false
                          }
                          , {
                            Header: 'Description',
                            accessor: 'Description',
                            show: false
                          }, {
                            Header: 'RunTime',
                            accessor: 'RunTime',
                            maxWidth: 120,
                            filterable: this.state.filter,

                          }, {
                            Header: 'Cluster',
                            accessor: 'Cluster',
                            maxWidth: 80,
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'Status',
                            accessor: 'Status',
                            maxWidth: 100,
                            filterable: this.state.filter,
                          }, {
                            Header: 'StartTime',
                            accessor: 'StartTime',
                            filterable: this.state.filter,
                          }, {
                            Header: 'EndTime',
                            accessor: 'EndTime',
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'hideCodeCells',
                            accessor: 'hideCodeCells',
                            show: false
                          },
                          {
                            Header: 'Cost',
                            accessor: 'Cost',
                            sortable: true,
                            filterable: this.state.filter,
                            maxWidth: 100
                          }, {
                            Header: 'createdBy',
                            accessor: 'createdBy',
                            maxWidth: 400,
                            filterable: this.state.filter,
                          }, {
                            Header: 'Comments',
                            accessor: 'Comments',
                            maxWidth: 90
                          },
                          // {
                          //   Header: 'Re-Run',
                          //   accessor: 'Rerun',
                          //   maxWidth: 70
                          // },
                          {
                            Header: 'Action',
                            accessor: 'Action',
                            maxWidth: 90
                          },
                          {
                            Header: 'InputFile',
                            accessor: 'InputFile',
                            show: false
                          },
                          {
                            Header: 'InputFolders',
                            accessor: 'InputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFile',
                            accessor: 'CodeFile',
                            show: false
                          },
                          {
                            Header: 'modelOutputCodeFolders',
                            accessor: 'modelOutputCodeFolders',
                            show: false
                          },
                          {
                            Header: 'modelOutputFolders',
                            accessor: 'modelOutputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFolders',
                            accessor: 'CodeFolders',
                            show: false
                          },
                          {
                            Header: 'OutputFile',
                            accessor: 'OutputFile',
                            show: false
                          }, {
                            Header: 'modelOutputCodeFiles',
                            accessor: 'modelOutputCodeFiles',
                            show: false
                          },
                          {
                            Header: 'Parameter',
                            accessor: 'Parameter',
                            show: false
                          },
                          {
                            Header: 'parameterSet',
                            accessor: 'parameterSet',
                            show: false
                          },
                          {
                            Header: 'LogFiles',
                            accessor: 'LogFiles',
                            show: false
                          },
                          {
                            Header: 'masterJobId',
                            accessor: 'masterJobId',
                            show: false
                          },
                        ]

                      }
                      defaultSorted={[
                        {
                          id: "StartTime",
                          desc: true
                        }
                      ]}
                      defaultPageSize={10}
                      pages={this.state.totalPages}
                      onPageChange={this.onPageChange}
                      SubComponent={(v) => <div>
                        <br />
                        <Row>
                          <Col lg="1"><span><b>Name :</b></span></Col>
                          <Col lg="3"><span >{v.row.fullName} 
                          </span></Col>
                          <Col lg="4"><span><b>Description :</b>&nbsp; &nbsp; &nbsp; {v.row.Description}</span></Col>
                          <Col lg="4">{v.row.scheduleId !== null &&<span style={{marginLeft:10}} onClick={e=>this.onClickSchedulerId(v.row.scheduleId)}><a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="far fa-clock pr-1" style={{ color: "#4776d9"}}></i>Scheduler Details</u> </a></span>}</Col>

                        </Row>
                        <br />
                        <Row>
                        <Col lg="4">{v.row.hideCodeCells}</Col>

                        </Row>
                        <Row>
                          <Col lg="1" style={{ marginTop: 10 }}><span><b>Tags :</b></span></Col>
                          <Col lg="10">
                            <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                              {v.row.Tags.map((item, index) => (
                                <Chip
                                  key={"tag-file-" + index}
                                  label={item}
                                  size="small"
                                  onDelete={(chip) => this.removeChip(v.row.DbId, index)}
                                  style={{ background: this.getColor(), color: "#fff", fontWeight: 600, marginTop: 5, marginLeft: 3 }}
                                />))}
                              <ChipInput
                                value={v.row.Tags}
                                placeholder="Add a Tag"
                                onAdd={value => this.addChip(v.row.DbId, value, v.row.Tags)}
                              />
                            </Scrollbars><br />
                            {/* <TagsInput value={v.row.Tags} onChange={evt => this.handleChangeTags(v.row.DbId, evt)}/> <br/> */}
                            {/* <Button className="tag-update-btn" onClick={e => this.CrateTags(v.row.DbId,v.row.Tags)}>Update</Button> */}
                          </Col>
                          <Col lg="1"></Col>
                        </Row>
                        <br />
                        <div>{(v.row.InputFile.length !== 0 || v.row.InputFolders.length > 0) &&
                          <span ><br /> <b>Model Input Files : &nbsp;<span style={styles.error}>{this.state.copiedmodelinput}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.InputFile.length + v.row.InputFolders.length) > 7 ? "scorllit" : ""}>
                                  <ul>
                                    {v.row.InputFolders.map((item, index) => (
                                      <li style={{ marginTop: 10 }} className="listyle" key={uuidv4()} 
                                      onContextMenu={e => e.preventDefault()}>
                                        <span
                                          className="file"
                                          data-type="folder"
                                          onClick={e => this.OpenStorageView(item, e, v.row.hideCodeCells)}
                                        >
                                          <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  {v.row.InputFile.map((item, index) => (
                                    <ul key={"in-file-" + index}>
                                      <li className="listyle" key={uuidv4()} >
                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                        <span className="file" data-type="file" data_attr_id={"codeId"+index+"b"}
                                          onContextMenu={this.handleClick}>
                                          <span className="text-primary"><i
                                              className={getImageFile(imageFileExtension(item))}></i></span>
                                          <a href={()=> false} className="text-primary" style={styles.chaticon}
                                            ><u>{item}</u> </a>
                                        </span>
                                          <DropdownToggle tag="span" id={"codeId"+index+"b"}>
                                          </DropdownToggle>
                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem onClick={e=> this.OpenStorageView(item,
                                              e,v.row.hideCodeCells)}
                                              >
                                              <span>
                                                <i className="fas fa-binoculars mr-2"></i> View
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem onClick={e=> this.downloadparticularFiles(item, item.runId,
                                              item.inputType)}
                                              >
                                              <span>
                                                <i className="fas fa-download mr-2" /> Download
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem onClick={e=> this.GetLink(item, e, 'modelinput')}
                                              >
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>
                                            </DropdownItem>

                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </td>
                              </tr>
                              </tbody>
                            </Table>
                          </span>
                        }
                        </div>
                        <br />
                        <div>{(v.row.CodeFile.length > 0 || v.row.CodeFolders.length > 0) &&
                          <span ><b>Model Code Files  : &nbsp;<span style={styles.error}>{this.state.copiedmodelcode}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.CodeFile.length + v.row.CodeFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.CodeFolders.map((item, index) => (
                                      <li key={"code-fol-" + index} style={{ marginTop: 10 }} className="listyle"
                                      onContextMenu={e => e.preventDefault()}>
                                        <span
                                          className="file"
                                          data-type="folder"
                                          onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                        >
                                          <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  {v.row.CodeFile.map((item, index) => (
                                    <ul key={"code-file-" + index}>
                                      <li className="listyle">
                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                        <span
                                              className="file"
                                              data-type="file"
                                              data_attr_id={"codeId"+index+"c"}
                                              onContextMenu={this.handleClick}
                                            >
                                              <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                              <a href={() => false} className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                            </span>
                                          <DropdownToggle tag="span" id={"codeId"+index+"c"}>
                                          </DropdownToggle>
                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem
                                              onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                            >
                                              <span >
                                                <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                            >
                                              <span >
                                                <i className="fas fa-download mr-2" /> Download
                </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => { this.GetLink(item, e, 'modelcode') }}
                                            >
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>

                                              {/* {this.state.copied ? <span style={{color: 'red'}}>Copied.</span> : null} */}



                                            </DropdownItem>

                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <div>{v.row.OutputFile.length !== 0 &&
                          <span ><b>Model Output Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputfile}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.OutputFile.length + v.row.modelOutputFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.modelOutputFolders.map((item, index) => (
                                      <li key={"modout-fol-" + index} style={{ marginTop: 10 }} className="listyle"
                                      onContextMenu={e => e.preventDefault()}>
                                        <span
                                          className="file"
                                          data-type="folder"
                                          onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                        >
                                          <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  <div className={(v.row.OutputFile.length + v.row.modelOutputFolders.length) > 7 ? "scrollit" : ""}>
                                    {v.row.OutputFile.map((item, index) => (
                                      <ul key={"out-file-" + index}>
                                        <li className="listyle">
                                          <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                          <span
                                                className="file"
                                                data-type="file"
                                                data_attr_id={"codeId"+index+"d"}
                                                onContextMenu={this.handleClick}
                                              >
                                                <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                                <a href={() => false} className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                              </span>
                                            <DropdownToggle tag="span" id={"codeId"+index+"d"}>
                                            </DropdownToggle>
                                            <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                              <DropdownItem
                                                onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                              >
                                                <span >
                                                  <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                              >
                                                <span >
                                                  <i className="fas fa-download mr-2" /> Download
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.GetLink(item, e, 'modeloutputfile')}
                                              >
                                                <div>
                                                  <i className=" fas fa-link mr-2" />
                                                  <span>Get Sharable Link</span>
                                                </div>
                                              </DropdownItem>

                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </li>
                                      </ul>
                                    ))}
                                  </div>
                                  {/*{v.row.OutputFile.length > 7  && <div className="scrollit">
                            {v.row.OutputFile.map((item,index) => (
                              <ul>
                                <li><span>
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                    <DropdownToggle tag="span" onClick={e => e.preventDefault()} style={{ color: '#007bff ' }}>
                                      <span
                                        className="file"
                                        data-type="file"
                                      // onClick={onFileClick}
                                      >
                                        <a className="text-primary" style={styles.chaticon} ><u>{item.filePath}</u> </a>
                                      </span>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item.filePath, e)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item.filePath, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item.filePath, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </span></li>
                              </ul>
                            ))}
                             </div>}*/}
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <div>{v.row.modelOutputCodeFiles.length !== 0 &&
                          <span ><b>Model Output Code Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputcodefile}</span></b> <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.modelOutputCodeFiles.length + v.row.modelOutputCodeFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.modelOutputCodeFolders.map((item, index) => (
                                      <li key={"mooutcode-fol-" + index} style={{ marginTop: 10 }} className="listyle"
                                      onContextMenu={e => e.preventDefault()}>
                                        <span
                                          className="file"
                                          data-type="folder"
                                          onClick={e => this.OpenStorageView(item, e,v.row.hideCodeCells)}
                                        >
                                          <a href={() => false} className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  <div>
                                    {v.row.modelOutputCodeFiles.map((item, index) => (
                                      <ul key={"modeoutcode-file-" + index}>
                                        <li className="listyle">
                                          <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                          <span className="file" data-type="file" data_attr_id={"codeId"+index+"e"}
                                            onContextMenu={this.handleClick}>
                                            <span className="text-primary"><i
                                                className={getImageFile(imageFileExtension(item))}></i></span>
                                            <a href={()=> false} className="text-primary" style={styles.chaticon}
                                              ><u>{item}</u> </a>
                                          </span>
                                          <DropdownToggle tag="span" id={"codeId"+index+"e"}>
                                          </DropdownToggle>
                                            <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                              <DropdownItem onClick={e=> this.OpenStorageView(item,
                                                e,v.row.hideCodeCells)}
                                                >
                                                <span>
                                                  <i className="fas fa-binoculars mr-2"></i> View
                                                </span>
                                              </DropdownItem>
                                              <DropdownItem onClick={e=> this.downloadparticularFiles(item, item.runId,
                                                item.inputType)}
                                                >
                                                <span>
                                                  <i className="fas fa-download mr-2" /> Download
                                                </span>
                                              </DropdownItem>
                                              <DropdownItem onClick={e=> this.GetLink(item, e, 'modeloutputcodefile')}
                                                >
                                                <div>
                                                  <i className=" fas fa-link mr-2" />
                                                  <span>Get Sharable Link</span>
                                                </div>
                                              </DropdownItem>

                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </li>
                                      </ul>
                                    ))}
                                  </div>
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <Row>
                          <Col lg="2">
                            {v.row.Parameter.length > 0 && <span><b>Business Levers : </b></span>}</Col>
                          <Col lg="4">
                            {v.row.Parameter.length > 0 && <span>
                              {
                                <Scrollbars autoHeight>
                                  {v.row.Parameter.length > 0 &&
                                    <Table responsive className="table-hover paratbl"
                                      id="tab_logic"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Variables </th>
                                          <th style={{ width: "80%" }}> Values </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {v.row.Parameter.map((item, index) => (
                                          item.row !== false &&
                                          <tr id="addr0" key={index}>
                                            <td className="variabletxt">{item.key}</td>
                                            <td style={{ width: "80%" }}>
                                              <Input
                                                className="form-control-alternative normaldisabled valuetxt"
                                                defaultValue={item.value}
                                                style={{ border: 'none', borderRadius: '5px' }}
                                                id={uuidv4()} 
                                                name="parameterSet"
                                                disabled
                                                type="text"
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  }
                                  {v.row.Parameter.length === 0 && <span style={{ color: 'darkgray', fontSize: '14px' }}>  &nbsp; No Business Levers Found</span>}


                                </Scrollbars>
                              }
                            </span>
                            }</Col>
                          <Col lg="2">
                            {v.row.Parameter.length > 0 &&
                              <img src={openpara} onClick={e => this.toggleModalParameter(v.row.Parameter, v.row.parameterSet)} style={{ cursor: 'pointer', width: '30px', height: '30px' }} alt="" />
                            }
                          </Col>
                        </Row>
                        <br />
                        
                        <div>
                          <span ><b>Log :</b>{
                            this.state.logState === false ?
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState, v.row.Id, v.row.LogFiles)}>Show</Button> :
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState, v.row.Id, v.row.LogFiles)}>Hide</Button>
                          }
                          </span>

                        </div>
                      </div>
                      }
                      // showPaginationTop
                      showPaginationBottom={true}
                      className="-striped -highlight primary-pagination tableHeight"
                    />

                  </TabPanel>
                  <TabPanel tabId = "Compare">
                  {this.state.tabId === "Compare" &&
                  <Analyze compareRow={this.state.compareRow} tabId={this.state.tabId} parentCallback = {this.handleCallback} ></Analyze>
                }
                  </TabPanel>
                  <TabPanel tabId="Catalog">
                    <Catalog />
                  </TabPanel>
                </Tabs>
             </Scrollbars>
              </div>
              </CardBody>
            </Card>
            <div>{this.state.logState && <Dialog
              title="Logs"
              modal={true}
              onClose={this.handleClose}
            // value={this.state.dialogid}
            >
              <LoadingOverlay
                active={this.state.modalloading}
                spinner={<HashLoader
                  size={50}
                  color={"#fff"}
                  loading={this.state.modalloading}
                />}
              >
                <Scrollbars style={styles.expandStyles_Comman} autoHeight autoHeightMin={400}
                  thumbMinSize={30} >
                  {(this.state.fileType === "others") &&

                    // <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                    //   {this.state.myContent}
                    // </p>
                    <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                      {this.state.myContent.split("\n").map((i, key) => {
                        return <div key={"mycontent-" + key}>{i}</div>;
                      })}
                    </p>
                  }
                </Scrollbars>
              </LoadingOverlay>
            </Dialog>}
            </div>
            <Modal isOpen={this.state.modalParameter} toggle={this.handleClose} className="parameter-modal" style={{ maxWidth: '700px' }}
            backdrop="static">
              {/* <div className="reactmodalbody"> */}
              <ModalBody>

                <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={600} >
                  <div>

                    <Tabs defaultTab="Default View" onChange={(tabId) => { 
                      // console.log(tabId)
                       }}>
                      <TabList>
                        <Row>
                          <div className="col">
                            <Tab tabFor="Default View" className="adddatatab"> Default View</Tab>
                            <Tab tabFor="Detailed View" className="adddatatab"> Detailed View</Tab>
                          </div>
                          <div className="col text-right">
                          <span style={{ cursor: 'pointer' }} onClick={e => this.handleClose()}>
                            <i className="fas fa-times text-red mr-3"></i>
                          </span>
                        </div>
                        </Row>
                      </TabList>
                      <TabPanel tabId="Default View">
                        <CardBody>
                          <Table responsive className="table-hover paratbl" id="tab_logic">
                            <thead>
                              <tr>
                                <th>Variables </th>
                                <th style={{ width: "80%" }}> Values </th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* {this.state.parasetTblState > 0 && */}
                              {this.state.parasetTblState.map((item, index) => (
                                item.row !== false &&
                                <tr id="addr0" key={index}>
                                  <td className="variabletxt">{item.key}</td>
                                  <td style={{ width: "80%" }}>
                                    <Input
                                      className="form-control-alternative normaldisabled valuetxt "
                                      defaultValue={item.value}
                                      style={{ border: 'none', borderRadius: '5px' }}
                                      id={uuidv4()} 
                                      name="parameterSet"
                                      disabled
                                      type="text"
                                    />
                                  </td>
                                </tr>
                              ))}
                              {/*  } */}
                            </tbody>
                          </Table>
                        </CardBody>
                      </TabPanel>
                      <TabPanel tabId="Detailed View">
                        <CardBody>
                          <div>
                            <FormGroup>
                              {/* <Input
                                className="form-control-alternative"
                                defaultValue={this.state.parasetvalue}
                                disabled
                                rows="12"
                                style={{ maxHeight: '800px', marginTop: 28, fontSize: '12px' }}
                                id={uuidv4()} 
                                name="parameterSet"
                                type="textarea"
                              /> */}
                              <Editor
                                    className="codeStyleDetailView"
                                    value={this.state.parasetvalue}
                                    id={uuidv4()} 
                                    disabled
                                    name="parameterSet"
                                    highlight={code => highlight(code, languages.py)}
                                    padding={10}
                                  />
                            </FormGroup>
                          </div>
                        </CardBody>
                      </TabPanel>
                    </Tabs>

                  </div>
                </Scrollbars>
              {/* </div> */}
              </ModalBody>
            </Modal>
            <Modal open={open} onClose={this.onCloseModal}>

              <div className="chatheader">
                <span style={{ fontSize: '14px' }}><b>Job - {this.state.commentid}</b> - Comments</span>
              </div>
              <Scrollbars autoHeight autoHeightMin={0}
                autoHeightMax={500}
                thumbMinSize={30} style={{ down: '5px', marginTop: '50px' }}>

                <ul className="chatul">
                  {this.state.chatMsg.map((item, index) => (

                    <li key={"chat-msg-" + index} className="chatcontent">
                      <Linkify>
                        <Media className="align-items-center">
                          <span className="avatar avatar-sm rounded-circle" >
                            {item.photoURL === null ? (
                              <img src={profileIcon} style={{ borderRadius: '50px' }} alt="" />
                            ) : <img src={item.photoURL} alt={item.firstName} style={{ borderRadius: '50px' }}
                              />}
                          </span>
                          <Media className="ml-2 d-none d-lg-block">
                            <span className="mb-0 text-sm font-weight-bold" style={{ fontSize: '14px' }}>
                              {item.firstName + "  " + item.lastName}
                            </span>
                            <p style={{ fontSize: '12px' }}>
                              <i className="ni location_pin mr-2" />
                              {item.createdDate !== null ? moment.utc(item.createdDate).local().format('MMM DD, YYYY HH:mm a') : ""}
                            </p>
                            <p><div className="chatp">{item.message}</div></p>
                          </Media>
                        </Media>
                      </Linkify>
                    </li>

                  ))}
                  <li className="chatcontent">
                    {this.state.messages.map((item, i) =>
                      <Linkify key={"msgs-" + i}>
                        <Media className="align-items-center">
                          <span className="avatar avatar-sm rounded-circle" >
                            {this.state.localPhoto === null ? (
                              <img src={profileIcon} style={{ borderRadius: '50px' }} alt="" />
                            ) : <img src={this.state.localPhoto} alt={this.state.localName} style={{ borderRadius: '50px' }}
                              />}
                          </span>
                          <Media className="ml-2 d-none d-lg-block">
                            <span className="mb-0 text-sm font-weight-bold" style={{ fontSize: '14px' }}>
                              {this.state.localName}
                            </span>
                            <p style={{ fontSize: '12px' }} >
                              <i className="ni location_pin mr-2" />
                              {moment.utc(new Date()).local().format('MMM DD, YYYY HH:mm a')}
                            </p>
                            <p><div className="chatp">{item}</div></p>
                          </Media>
                        </Media>
                      </Linkify>
                    )}
                    <div>
                    </div>
                  </li>
                </ul>

              </Scrollbars>
              <div className="chatfooter">
                <div style={{ down: 2, position: 'absolute', backgroundColor: "#efefef", right: 0, borderRadius: "17px" }}>
                  {this.state.showuserListFlag &&
                    <Scrollbars autoHeight autoHeightMin={0} autoHeightMax={130}>
                      {this.state.UserList.map((item, index) => (<ul>
                        <li key={"user-li-" + index} style={{ marginTop: "10px" }} onClick={e => this.userselectedValue(item.firstName, item.lastName, item.email)}>
                          <span className="avatar avatar-sm rounded-circle">
                            {item.photoURL === null ? (
                              <img src={profileIcon} alt="" />
                            ) : <img src={item.photoURL} alt={item.firstName}
                              />}
                          </span>
                          <span ><a href={() => false} className="text-primary" style={{ cursor: 'pointer', position: "absolute", marginTop: "10px", marginLeft: "20px" }}>{item.firstName + " " + item.lastName} </a></span></li>
                      </ul>))}
                    </Scrollbars>}
                  {this.state.input_user.map((item, index) => (<Chip
                    key={"in-user-" + index}
                    label={item}
                    onDelete={e => this.handleDelete(item)}
                  />))}
                  <Input className="form-control-alternative chattext" type="text" onChange={this.handleChange}
                    onKeyDown={this.keyPressed} autoFocus
                    value={this.state.input} placeholder="Type a message" /><br></br>
                </div>
              </div>

            </Modal>
            </LoadingOverlay>

          </div>
        </>
    );
  }
}

export default Runs;
